export default __webpack_public_path__ + "static/media/backgroundmobile.7a209528.png";